<template>
    <tr @click="recordSelected">
        <td>{{ markRecord.count }}</td>
        <td class="pt-1">
            {{ markRecord.name }}
        </td>        
        <td v-if="!termTwo">
            <v-text-field
                v-model="markRecord.course_mark"
                outlined
                dense
                :filled="disableCourseMark"
                :disabled="disableCourseMark"
                hide-details 
                type="number"               
                min=0
                max=100
                @keypress="numberValidation"
                @blur="recordChanged('course_mark')"

                
            ></v-text-field>
        </td>        
        <td v-if="!termTwo">
            <v-text-field
                v-model="markRecord.exam_mark"
                outlined
                dense
                hide-details
                type="number"
                min=0
                max=100
                @keypress="numberValidation"                
                @blur="recordChanged('exam_mark')"
                :filled="disableExamMark"
                :disabled="disableExamMark"
            ></v-text-field>
        </td>
        <td v-if="termTwo">
            <v-text-field
                v-model="markRecord.test_1"
                outlined
                dense
                hide-details
                type="number"
                min=0
                max=35                
                @blur="recordChanged('test_1')"
                @keypress="numberValidation"
                :filled="disableExamMark"
                :disabled="disableExamMark"
               
            ></v-text-field>
        </td>
        <td v-if="termTwo">
            <v-text-field
                v-model="markRecord.test_2"
                outlined
                dense
                hide-details
                type="number"
                min="0"
                max="35"
                @blur="recordChanged('test_2')"
                @keypress="numberValidation"
                :filled="disableExamMark"
                :disabled="disableExamMark"
            ></v-text-field>
        </td>
        <td v-if="termTwo">
            <v-text-field
                v-model="markRecord.project"
                outlined
                dense
                hide-details
                type="number"
                min=0
                max=30
                @blur="recordChanged('project')"
                @keypress="numberValidation"
                :filled="disableExamMark"
                :disabled="disableExamMark"
            ></v-text-field>
        </td>        
        <td>
            <v-menu
                v-model="menu"
                :close-on-content-click="false"
                bottom
                origin="center center"
                transition="scale-transition"
            >
                <template v-slot:activator="{ on, attrs }">
                    <v-btn 
                        depressed
                        v-bind="attrs"
                        v-on="on"
                        style="font-size:0.6rem; text-transform: none; font-style: italic;"
                        small
                        block
                    >
                    {{  subjectRemarks }}    
                    </v-btn>
                </template>

                <v-card width="50vw">
                    <v-card-title> {{ markRecord.name }} Subject Remarks</v-card-title>
                    <v-container>
                        <v-row>
                            <v-col cols="6">
                                <v-select
                                    v-model="codedComment"                
                                    :items="comments1"
                                    item-value="id"
                                    outlined
                                    dense
                                    hide-details
                                    return-object                
                                    @change="recordChanged('codedComent')"                
                                >
                                    <template v-slot:selection="{item}">
                                        {{ item.comment }}
                                    </template>
                    
                                    <template
                                        v-slot:item=data
                                    > 
                                        {{ data.item.id}} {{ data.item.comment }}
                                    </template> 
                    
                                </v-select>
                            </v-col>

                            <v-col cols="6">
                                <v-select
                                    v-model="codedComment1"                
                                    :items="comments2"
                                    item-value="id"
                                    outlined
                                    dense
                                    hide-details
                                    return-object                
                                    @change="recordChanged('codedComment1')"                
                                >
                                    <template v-slot:selection="{item}">
                                        {{ item.comment }}
                                    </template>
                        
                                    <template
                                        v-slot:item=data
                                    > 
                                        {{ data.item.id}} {{ data.item.comment }}
                                    </template> 
                        
                                </v-select>
                            </v-col>
                        </v-row>
                    </v-container>

                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                            color="primary"
                            depressed
                            @click="menu = false"
                        >
                            Close
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-menu>
        </td>            
        <!-- <td>
        </td> -->
        <td>
            <v-tooltip 
                bottom
                
            >
                <template v-slot:activator="{ on, attrs }">
                    <v-icon
                        small
                        color="primary"                        
                        v-bind="attrs"
                        v-on="on"
                        v-show="saved"
                        class="mr-2"
                    >
                        mdi-check-all
                    </v-icon>
                </template>    
                <span>Saved</span>                
            </v-tooltip>
            <v-tooltip 
                top
                
            >
                <template v-slot:activator="{ on, attrs }">
                    <v-icon
                        small
                        color="red"                       
                        v-bind="attrs"
                        v-on="on"
                        v-show="error"
                    >
                        mdi-alert-circle
                    </v-icon>
                </template>    
                <span>Error</span>               
            </v-tooltip>
            <v-progress-circular
                indeterminate
                color="primary"
                v-show="saving"
                size="16"
                width="3"
            ></v-progress-circular>
        </td>
    </tr>

    
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
export default {
    props:{
        studentRecord: Object,        
    },
    created () {
        this.initialize();
    },  
    watch: {        
        codedComments: {
            deep: true,
            handler(value){
                if(value.length != 0){
                    this.setComments();
                }
            }
        },
        codedComment: {
            handler(value){
                //console.log(value);
                this.markRecord.coded_comment = value.id;
            }
        },
        codedComment1: {
            handler(value){
                //console.log(value);
                this.markRecord.coded_comment_1 = value.id;
            }
        },
       
    },       
    data() {
        return {
            commentsConduct: [],
            commentsApplication: [],
            commentsPreparedness: [],            
            comments1: [],
            comments2: [],            
            markRecord: {},
            codedComment: { id: null, comment: null },
            codedComment1: { id: null, comment: null },
            conduct: { id: null, comment: null },
            application: { id: null, comment: null },
            preparedness: { id: null, comment: null },            
            comments3: [
                { id: null, comment: null},
                { id: 1, comment: 'Excellent' },
                { id: 2, comment: 'Good' },
                { id: 3, comment: 'Satisfactory' },
                { id: 4, comment: 'More Effort Required' },
                { id: 5, comment: 'Cause for Concern' },
            ],
            selectColumns:[
                { text: 'Conduct', model: 'conduct' }
            ],
            saved: false,
            saving: false,
            error: false,
            disableConduct: false,
            disableApplication: false,
            disablePreparedness: false,
            disableCodedComment: false,
            disableCodedComment1: false,
            disableExamMark: false,
            disableCourseMark: true,
            termTwo: false, 
            menu: false,          
        }
    },
    computed: {
        ...mapGetters({
            codedComments: 'termReports/getCodedComments',
            employeeId: 'auth/getEmployeeId',
            marksEntered: 'termReports/getSubjectStudentsMarksEntered',
            lessonSelected: 'termReports/getLessonSelected',
            table2Records: 'termReports/getTable2Records',
            currentTerm: 'termReports/getCurrentTerm', 
        }),

        total(){
            let formLevel = this.lessonSelected.formLevel;
            
            if(formLevel == 5) return 'NA';
            else if(this.currentTerm == 2){
                if(formLevel == 6) return 'NA'
            }
            else if(this.currentTerm == 3){
                if(formLevel == 3 || formLevel == 4) return 'NA'
            }
            return (this.markRecord.course_mark * 0.6 + this.markRecord.exam_mark * 0.4).toFixed(1);
        },
        
        subjectRemarks () {
            const comment1 = this.codedComments.find(comment => comment.id === this.codedComment.id)?.detail ?? null;
            const comment2 = this.codedComments.find(comment => comment.id === this.codedComment1.id)?.detail ?? null;
            if(comment1 && comment2) return `${comment1} / ${comment2}`
            if(comment1) return `${comment1}`
            if(comment2) return `${comment2}`
            return null;
        }
    },
    methods : {
        ...mapMutations({
            setUpdatedRecord: 'termReports/setUpdatedTable2Record',
            setStudentSelected: 'termReports/setMarkSheetStudentSelected',
            setMarkSheetEntered: 'termReports/setSubjectStudentsMarksEntered',
            setOverlayError: 'enterMarks/setOverlayError',
            setError: 'enterMarks/setError',
        }),

        ...mapActions({
            save: 'termReports/saveTable2Record',
        }),

        async recordChanged(model){
            //console.log(this.recordBlankCheck());
            if(!this.recordBlankCheck() && this.markValid(model)){
                console.log('record changed...');            
                this.saving = true;
                this.saved = false;
                this.error = false;
                this.setUpdatedRecord(
                {
                    "student_id" : this.markRecord.student_id,
                    "year" : this.markRecord.year,
                    "term" : this.markRecord.term,
                    "subject_id" : this.markRecord.subject_id,
                    "exam_mark" : this.markRecord.exam_mark,
                    "course_mark" : this.markRecord.course_mark,
                    "test_1" : this.markRecord.test_1,
                    "test_2" : this.markRecord.test_2,
                    "project" : this.markRecord.project,
                    "coded_comment" : this.codedComment.id,
                    "coded_comment_1" : this.codedComment1.id,
                    "employee_id" : this.employeeId,                   
                }
            );
                let response = await this.save();
                //console.log(response);

                if(response && (response.status === 200 || response.status === 201)){
                    this.saving = false;
                    this.saved = true;
                    this.error = false;
                    //console.log(this.marksEntered);
                    //let entered = this.marksEntered;
                    //this.setMarkSheetEntered(++entered);
                }
                else{
                    this.saving = false;
                    this.error = true;
                    this.saved = false;
                }    
            }                  
        },
        recordBlankCheck(){
            let record = [];
            let blank = true;
            //console.log(this.markRecord);
            record.push(this.markRecord.course_mark);
            record.push(this.markRecord.exam_mark);           
            record.push(this.markRecord.test_1);           
            record.push(this.markRecord.test_2);           
            record.push(this.markRecord.project);           
            record.push(this.markRecord.coded_comment);
            record.push(this.markRecord.coded_comment_1);
            //console.log(record);
            //console.log(this.markRecord['coded_comment']);
            record.forEach(element => {
                if(element) blank = false;
            })

            // if(this.markRecord.course_mark || this.markRecord.exam_mark || this.markRecord.coded_comment || this.markRecord.coded_comment_1){
            //     console.log('not blank');
            //     return false
            // }
            // console.log('blank');
            return blank;
        },
        savedDataCheck(){
            if(!this.recordBlankCheck()) this.saved = true;
        },
        recordSelected(){
            //console.log('marksheetrecord: ', this.markRecord);
            console.log("record selected");
            // let records = this.table2Records;
            //console.log(records);
           
            // console.log(entered);
            //console.log(records);          
            this.setStudentSelected(this.markRecord.name);
        },        
        setComments(){ 
            this.comments1.push({id: null, comment: null});  
            this.comments2.push({id: null, comment: null});
            //console.log(this.codedComments);  
            this.codedComments.forEach(record =>{
                this.comments1.push({ id: parseInt(record.id), comment: record.detail });
                this.comments2.push({ id: parseInt(record.id), comment: record.detail });
            });           
            
            if(this.studentRecord.coded_comment){
                this.codedComment = { id: parseInt(this.studentRecord.coded_comment) };
            } 
            if(this.studentRecord.coded_comment_1){
                this.codedComment1 = { id: parseInt(this.studentRecord.coded_comment_1) };
            }
            
        },
        setDisabledFields(){           
            
            if(this.currentTerm == 2 && this.lessonSelected.formLevel < 5){
                this.termTwo = true;            
            }
            
        },
        initialize(){
            this.markRecord = {...this.studentRecord};
            //console.log(this.markRecord);
            this.savedDataCheck();
            this.setComments();
            //console.log('initializing..')
            this.setDisabledFields();
            //if(this.currentTerm == 2) this.termMarkOnly = true;
            //console.log(this.currentTerm);
        },
 
        numberValidation ($event) {
            if($event.keyCode < 48 || $event.keyCode > 57)
            return $event.preventDefault();
        },

        markValid (model) {
            let value = this.markRecord[model];
            if(value && model == 'test_1' && value > 35){
                this.markRecord[model] = null;
                this.setOverlayError(true);
                this.setError({
                    response: 'Test 1 Cannot be greater than 35.'
                })
                return false;
            }
            else if(value && model == 'test_2' && value > 35){
                this.markRecord[model] = null;
                this.setOverlayError(true);
                this.setError({
                    response: 'Test 2 Cannot be greater than 35.'
                })
                return false;
            }
            else if(value && model == 'project' && value > 30){
                this.markRecord[model] = null;
                this.setOverlayError(true);
                this.setError({
                    response: 'Project Cannot be greater than 30.'
                })
                return false;
            }
            else if(value && model == 'course_mark' && value > 100){
                this.markRecord[model] = null;
                this.setOverlayError(true);
                this.setError({
                    response: 'Course Mark Cannot be greater than 100.'
                })
                return false;
            }
            else if(value && model == 'exam_mark' && value > 100){
                this.markRecord[model] = null;
                this.setOverlayError(true);
                this.setError({
                    response: 'Exam Mark Cannot be greater than 100.'
                })
                return false;
            }         
            return true;
        }
    }
}
</script>

<style scoped>
    /* Chrome, Safari, Edge, Opera */
    ::v-deep input::-webkit-outer-spin-button,
    ::v-deep input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
    text-align:center
    }

    /* Firefox */
    ::v-deep input[type=number] {
        appearance: textfield;
        -moz-appearance: textfield;
        -webkit-apperance: none;
    }
</style>